import getApiClient from '@/plugins/api'
import fileValidator from '@/helpers/fileValidator'
import {clone, cloneDeep} from 'lodash'
import Vue from 'vue'
import moment from 'moment'

export default {
    loadTrip: function (cloneFrom = null) {
        const self = this,
            id = self.$route.params.id ?? cloneFrom,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.get(`/trips/${id}`)
            .then((result) => {
                self.trip = result.data
                self.trip.accommodations = self.trip.accommodations.filter(accommodation => {
                    return accommodation.status
                })
                self.$refs.placeSelect.display = result.data.place.name
                self.$refs.placeSelect.value = result.data.place.id

                cloneFrom > 0 ? self.setClonedDates() : null

                self.gallery = result.data.images.map((image) => {
                    image.thumb = this.viewImage(image)
                    return image
                })

                api.get(`orders`, {
                    params: {
                        status: 3,
                        'trip.id': self.trip.id
                    }
                })
                    .then((ordersResult) => {
                        self.blockRemoval = ordersResult.data['hydra:totalItems'] > 0
                    })
                    .catch((error) => {
                    })
                    .finally(() => {
                        self.$store.commit('stopLoading')
                    })
            })
            .catch((error) => {
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    resetTrip: function () {
        this.trip = {
            boardingPlaces: [],
            accommodations: [],
            optionals: [],
            place: {
                name: null,
                id: null
            }
        }
        this.$refs['placeSelect'].display = null
        this.success = false
        this.error = false
    },

    processForm: function (goToAds = false) {
        const self = this
        self.error = false
        self.errorMessage = ''

        self.resetErrors()

        // inserts trip start date based on first boarding date
        if (self.trip.boardingPlaces.length > 0) {
            self.trip.startTime = self.trip.boardingPlaces.slice(0, 1).pop().date ?? null
        }

        if (!self.validateForm()) {
            return
        }

        self.$route.params.id ? self.updateTrip(goToAds) : self.createTrip(goToAds)
        return
    },

    createTrip: function (goToAds = false) {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')
        self.success = false
        self.error = false
        self.errorMessage = ''

        let data = self.reduceTripData()

        api.post(`/trips`, data)
            .then((result) => {
                self.success = true
                self.trip = result.data
                if (!goToAds) {
                    self.$router.push({
                        name: 'Editar Trip',
                        params: {
                            id: result.data.id
                        }
                    })
                } else {
                    self.$router.push({
                        name: 'Divulgação',
                        params: {
                            tripId: result.data.id
                        }
                    })
                }
            })
            .catch((error) => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        self.processValidationErrors(error.response.data)
                        break;
                    case 500:
                        self.error = true
                        break;
                }
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    updateTrip: function (goToAds = false) {
        const self = this,
            id = self.$route.params.id,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')
        self.success = false
        self.error = false
        self.errorMessage = ''

        let data = self.reduceTripData()

        api.patch(`/trips/${id}`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                self.success = true
                self.trip = result.data
                self.$scrollTo(document.body)

                if (goToAds) {
                    self.$router.push({
                        name: 'Divulgação',
                        params: {
                            tripId: result.data.id
                        }
                    })
                }
            })
            .catch((error) => {
                switch (error.response?.status) {
                    case 400:
                    case 422:
                        self.processValidationErrors(error.response?.data)
                        break;
                    default:
                        self.error = true
                        break;
                }
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    parseDate(dateString, format) {
        if (dateString.length >= 16) {
            return moment(dateString, format).toDate()
        }
    },

    openCropper(files, model, index = null) {
        const self = this

        let image = ''
        if (model === 'cover') {
            image = files[0]
        }

        self.croppingModel = model

        if (model === 'gallery') {
            if (files.name.match(/base64/)) {
                self.croppingImage = files.name
            } else {
                self.croppingImage = files.thumb
            }

            self.currentGalleryImageCrop = index
            self.showCropper = true
            return;
        }

        const valid = fileValidator(image, {
            maximumSize: (1024 * 2000)
        })

        if (!valid.result) {
            alert(valid.message)
            return
        }

        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
            self.croppingImage = e.target.result
            self.showCropper = true
        }
    },

    closeCropper() {
        this.croppingImage = null
        this.showCropper = false
        this.croppingModel = null
    },

    setImage() {
        const { canvas } = this.$refs.imageCropper.getResult()
        switch (this.croppingModel) {
            case 'cover':
                this.trip.cover = canvas.toDataURL('image/jpeg', 70)
                break;
            case 'gallery':
                if (this.currentGalleryImageCrop) {
                    const result = canvas.toDataURL('image/jpeg', 70)
                    this.gallery[this.currentGalleryImageCrop].thumb = result
                    this.gallery[this.currentGalleryImageCrop].name = result
                    this.gallery[this.currentGalleryImageCrop].blob = result
                }
                break;
        }
        this.croppingImage = null
        this.showCropper = false
        this.croppingModel = null
    },

    setImages() {
        const self = this

        const images = [];

        self.gallery.forEach((image) => {
            images.push({
                id: image['@id'] ?? null,
                '@id': image['@id'] ?? null,
                name: image.name,
                caption: image.caption
            });
        })

        return images
    },

    setPlace: function (data) {
        this.trip.place = {}
        this.trip.place.name = data.name
        this.trip.place.id = data.value
    },

    resetPlace: function () {
        this.trip.place = {
            name: '',
            id: ''
        }
    },

    setPeopleType(peopleType, data) {
        peopleType.peopleType = `/people_types/${data.value}`
    },

    reduceTripData: function () {
        let trip = _.cloneDeep(this.trip)

        trip.images = this.setImages()

        if (this.$route.params.clone) {
            this.prepareForClone(trip)
        }

        if (trip.place?.id) {
            trip.place = `/places/${trip.place.id}`
        } else {
            trip.place = null
        }

        let accommodations = trip.accommodations
        for (let index in accommodations) {
            let accommodation = accommodations[index]
            if (accommodation?.accommodation?.id) {
                accommodation.accommodation = `/accommodations/${accommodation.accommodation.id}`
            } else {
                accommodation.accommodation = null
            }

            let peopleTypeValue = accommodation.peopleTypeValue
            peopleTypeValue.forEach((peopleTypeValue) => {
                if (peopleTypeValue?.peopleType?.id) {
                    peopleTypeValue.peopleType = `/people_types/${peopleTypeValue.peopleType.id}`
                }
                if (typeof peopleTypeValue.peopleType !== 'string' && this.$route.name === 'Criar Trip' && !this.$route.params.clone) {
                    peopleTypeValue.peopleType = null
                }

                if (peopleTypeValue.price !== undefined) {
                    peopleTypeValue.value = peopleTypeValue.price.toString()
                }
            })
        }

        let optionals = trip.optionals
        optionals.forEach((optional) => {
            if (optional.price) {
                optional.value = optional.price.toString()
            }
        })

        let boardingPlaces = trip.boardingPlaces
        for (let index in boardingPlaces) {
            if (
              typeof boardingPlaces[index].boardingPlace === 'object' &&
              boardingPlaces[index].boardingPlace.hasOwnProperty('@id')
            ) {
                boardingPlaces[index].boardingPlace = boardingPlaces[index].boardingPlace['@id']
            }
        }

        // If editing Trip, we just send the relationships IDs
        if (this.$route.params.id) {
            let boardingPlaces = trip.boardingPlaces
            for (let index in boardingPlaces) {
                let boardingPlace = boardingPlaces[index]
                if (boardingPlace['@id']) {
                    boardingPlaces[index]['id'] = boardingPlaces[index]['@id']
                }

                if (
                  typeof boardingPlaces[index].boardingPlace === 'object' &&
                  boardingPlaces[index].boardingPlace.hasOwnProperty('@id')
                ) {
                    boardingPlaces[index].boardingPlace = boardingPlaces[index].boardingPlace['@id']
                }
            }

            let accommodations = trip.accommodations
            for (let index in accommodations) {
                let accommodation = accommodations[index]
                if (accommodation['@id']) {
                    accommodations[index]['id'] = accommodation['@id']
                    accommodations[index].peopleTypeValue.forEach((peopleTypeValue) => {

                        if (!peopleTypeValue?.peopleType?.id && typeof peopleTypeValue.peopleType !== 'string') {
                            peopleTypeValue.peopleType = null
                        }

                        if (peopleTypeValue?.peopleType?.id) {
                            peopleTypeValue.peopleType = `/people_types/${peopleTypeValue.peopleType.id}`
                        }

                        if (peopleTypeValue['@id']) {
                            peopleTypeValue.id = peopleTypeValue['@id']
                        }
                    })
                } else {
                    accommodations[index].peopleTypeValue.forEach((peopleTypeValue) => {
                        if (!peopleTypeValue?.peopleType?.id && typeof peopleTypeValue.peopleType !== 'string') {
                            peopleTypeValue.peopleType = null
                        }
                    })
                }

            }

            let optionals = trip.optionals
            for (let index in optionals) {
                let optional = optionals[index]
                if (optional['@id']) {
                    optionals[index]['id'] = optional['@id']
                }
            }
        }

        return trip
    },

    addBoardingPlace: function () {
        this.trip.boardingPlaces.push({})
        let totalBoardingDates = this.trip.boardingPlaces.length

        let index = totalBoardingDates - 1
        if(totalBoardingDates > 1) {
            index = totalBoardingDates - 2
        }

        this.lastBoardingDate = this.trip.boardingPlaces[index].date
    },

    removeBoardingPlace: function (boardingPlace) {
        const self = this

        this.trip.boardingPlaces = this.trip.boardingPlaces.filter((place, index) => {
            // Clear error message
            Vue.set(self.errors, `boardingPlaces[${index}].date`, undefined)

            return place !== boardingPlace
        })
    },

    toggleBoardingPlaceStatus: function (boardingPlace) {
        const self = this,
          api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.patch(boardingPlace['@id'], {
            status: !boardingPlace.status
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
          .then(() => {
              boardingPlace.status = !boardingPlace.status
              this.loadTrip(this.$route.params.clone || null)
          })
          .finally(() => {
              self.$store.commit('stopLoading')
          })
    },

    addAccommodation: function () {
        let accommodation = {
            accommodation: {id: 1},
            peopleTypeValue: [],
            errors: {
                name: null
            }
        }

        this.trip.accommodations.push(accommodation)
        this.addAccommodationPeopleTypeValue(accommodation)
    },

    removeAccommodation: function (accommodationItem) {
        this.trip.accommodations = this.trip.accommodations.filter((accommodation) => {
            return accommodation !== accommodationItem
        })
    },

    addAccommodationPeopleTypeValue: function (accommodation) {
        accommodation.peopleTypeValue.push({
            peopleType: {id: 1}
        })
    },

    removeAccommodationPeopleTypeValue: function (accommodation, accommodationPeopleTypeValueItem) {
        accommodation.peopleTypeValue = accommodation.peopleTypeValue.filter((peopleTypeValue) => {
            return peopleTypeValue !== accommodationPeopleTypeValueItem
        })
    },

    addOptional: function () {
        this.trip.optionals.push({
            price: null,
            name: null
        })
    },

    removeOptional: function (optional) {
        this.trip.optionals = this.trip.optionals.filter((optionalItem) => {
            return optional !== optionalItem
        })
    },

    processValidationErrors: function (errors) {
        const self = this

        if (errors.violations) {
            errors.violations.forEach((violation) => {
                Vue.set(self.errors, violation.propertyPath, violation.message)
            })

            self.error = 400

            self.goFirstError()
        }
    },

    goFirstError() {
        const self = this
        window.setTimeout(function() {
            let firstError = document.getElementsByClassName('invalid-feedback')[0]

            self.$scrollTo(firstError)
        }, 200)
    },

    prepareForClone(trip) {
        trip.id = null
        trip.agency = null

        let accommodations = trip.accommodations
        accommodations.forEach((accommodation) => {
            accommodation.id = null
            accommodation['@id'] = null

            let peopleTypeValues = accommodation.peopleTypeValue
            peopleTypeValues.forEach((peopleTypeValue) => {
                peopleTypeValue.id = null
                peopleTypeValue['@id'] = null
            })
        })

        let optionals = trip.optionals
        optionals.forEach((optional) => {
            optional.id = null
            optional['@id'] = null
        })

        let boardingPlaces = trip.boardingPlaces
        boardingPlaces.forEach((boardingPlace) => {
            boardingPlace.id = null
            boardingPlace['@id'] = null
        })

        const baseUrl = process.env.VUE_APP_BASE_URL
        let images = trip.images
        images.forEach((image) => {
            image.id = null
            image['@id'] = null
        })
    },

    resetErrors: function () {
        this.errors = {
            eventTitle: null,
            place: null,
            startTime: null,
            stopTime: null,
            cover: null,
            description: null,
            itinerary: null,
            boardingPlaces: [],
            accommodations: [],
            optionals: [],
            returnPlace: null,
            isIncluded: null,
            isNotIncluded: null,
            term: null,
            summary: null,
            kid_conditions: null,
            pet_conditions: null
        }
    },

    loadAvailableAccommodations() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')
        api.get('accommodations')
            .then(result => {
                let data = result.data['hydra:member']

                self.availableAccommodations = data.map(accommodation => {
                    return {
                        label: accommodation.name,
                        value: accommodation.id
                    }
                })
            })
            .catch(() => {})
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    loadAvailablePeopleTypes() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')
        api.get('people_types')
            .then(result => {
                let data = result.data['hydra:member']

                self.availablePeopleTypes = data.map(peopleType => {
                    return {
                        label: peopleType.name,
                        value: peopleType.id
                    }
                })
            })
            .catch(() => {})
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    isFirstItem(index) {
        return index === 0;
    },

    isPastDateFirstItem(date) {
        let currentDate = new Date()

        if (this.trip.boardingPlaces[0].date) {
            currentDate = new Date(this.trip.boardingPlaces[0].date)
        }

        return date <= currentDate.setDate(currentDate.getDate() - 1)
    },

    isPastDate(date) {
        const currentDate = new Date()
        return date < currentDate.setDate(currentDate.getDate() - 1)
    },

    getLastDateBoardingPlaces() {
        let date = new Date()
        let lastDate = this.trip.boardingPlaces ? this.trip.boardingPlaces.slice(-1).pop() : []
        let currentDate = this.trip.stopTime

        if(!currentDate && lastDate && lastDate.date) {
            date = new Date(lastDate.date)
        }

        if (currentDate) {
            date = new Date(currentDate)
        }

        return {
            month: date.getMonth(),
            year: date.getFullYear()
        }
    },

    isLastDateBoardingPlaces(date) {
        let dateBase = new Date()
        let lastDate = this.trip.boardingPlaces.slice(-1).pop()

        if (lastDate && lastDate.date) {
            dateBase = new Date(lastDate.date)
        }

        return date <= dateBase.setDate(dateBase.getDate() - 1)
    },

    validateForm() {
        const self = this

        self.validateBasicFields()
        self.validateDate()
        self.validateShipmentHasBeenDefined()
        self.validateAccommodationDefined()
        self.validateIfThereAdult()

        if (self.error) {
            self.$store.commit('stopLoading')
            self.goFirstError()
            return false
        }

        return true
    },

    validateBasicFields() {
        const self = this

        if (! self.trip.eventTitle) {
            Vue.set(
              self.errors,
              `eventTitle`,
              'Este campo é obrigatório'
            )
            self.error = 400
        }

        if (! self.trip.place?.id) {
            Vue.set(
              self.errors,
              `place`,
              'Este campo é obrigatório'
            )
            self.error = 400
        }

        if (! self.trip.cover) {
            Vue.set(
              self.errors,
              `cover`,
              'Este campo é obrigatório'
            )
            self.error = 400
        }
    },

    validateDate() {
        const self = this

        if (! self.trip.startTime) {
            Vue.set(
                self.errors,
                `startTime`,
                'Este campo é obrigatório'
            )
            self.error = 400
        }

        if (! self.trip.stopTime) {
            Vue.set(
                self.errors,
                `stopTime`,
                'Este campo é obrigatório'
            )
            self.error = 400
        }

        self.trip.boardingPlaces.forEach((array, index) => {
            if (! array.date) {
                Vue.set(
                    self.errors,
                    `boardingPlaces[${index}].date`,
                    'Este campo é obrigatório'
                )
                self.error = 400
            }

            if (! array.boardingPlace) {
                Vue.set(
                  self.errors,
                  `boardingPlaces[${index}].boardingPlace`,
                  'Este campo é obrigatório'
                )
                self.error = 400
            }
        })
    },

    validateShipmentHasBeenDefined() {
        const self = this

        if (! self.trip.boardingPlaces.length) {
            self.errorMessage = self.validationErrorMessages.boardingPlaces.mandatory
            self.error = true
        }
    },

    validateAccommodationDefined() {
        const self = this

        if (! this.trip.accommodations.length) {
            self.errorMessage = self.validationErrorMessages.accommodations.mandatory
            self.error = true
        }
    },

    validateIfThereAdult() {
        const self = this

        if (! this.trip.accommodations.length) {
            return
        }

        this.trip.accommodations.forEach((accommodation, index) => {
            if (! accommodation.peopleTypeValue.length) {
                return
            }

            let adultCounter = 0
            let peopleTypeValue = accommodation.peopleTypeValue

            peopleTypeValue.forEach((peopleTypeValue) => {
                if (peopleTypeValue?.peopleType?.id === 1) {
                    adultCounter++
                }
            })

            if (adultCounter === 0) {
                Vue.set(
                    self.errors,
                    `accommodations[${index}].peopleTypeValue[0].peopleType`,
                    self.validationErrorMessages.accommodations.mandatoryAdult
                )

                self.error = 400
            }
        })
    },

    dateRangeValidation() {
        const self = this

        let date = new Date()

        this.trip.boardingPlaces.forEach((value, index) => {
            if (!value.date) {
                return
            }

            if (index === 0) {
                date = new Date(value.date)
                return
            }

            let date1 = date
            let date2 = new Date(value.date)

            let msec = date2 - date1
            let mins = Math.floor(msec / 60000)

            date = new Date(value.date)

            if (mins > 0 && mins < 480) {
                return
            }

            let errorMessage = mins < 0 ?
                self.validationErrorMessages.boardingPlaces.dateLess :
                self.validationErrorMessages.boardingPlaces.intervalBetweenDates

            Vue.set(
                self.errors,
                `boardingPlaces[${index}].date`,
                errorMessage
            )

            self.error = 400
        })
    },

    setClonedDates() {
        const date = new Date()
        const self = this

        const dateFormat = moment(date).add(1, 'month').format('YYYY-MM-DD')

        self.trip.startTime = dateFormat
        self.trip.stopTime = dateFormat

        if (! this.trip.boardingPlaces.length) {
            return
        }

        this.trip.boardingPlaces.forEach((boardingPlace) => {
            if (!boardingPlace.date) {
                return
            }

            boardingPlace.date = `${dateFormat} 00:00`
        })
    },

    inputFilter(newFile, oldFile, prevent) {
        const valid = fileValidator(newFile, {
            allowedTypes: 'jpg|jpeg|png',
            maximumSize: (512 * 2000)
        })

        if (!valid.result) {
            alert(valid.message)
            return prevent()
        }

        if (newFile && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
            // Create a blob field
            newFile.blob = ''
            let URL = (window.URL || window.webkitURL)
            if (URL) {
              newFile.blob = URL.createObjectURL(newFile.file)
            }

            // Thumbnails
            newFile.thumb = ''
            if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
              newFile.thumb = newFile.blob
            }
        }

        if (newFile && newFile.error === '' && newFile.type.substr(0, 6) === "image/" && newFile.blob && (!oldFile || newFile.blob !== oldFile.blob)) {
            newFile.error = 'image parsing'
            let img = new Image();
            img.onload = () => {
              this.$refs.upload.update(newFile, {error: '', height: 700, width: 500})
            }
            img.οnerrοr = (e) => {
              this.$refs.upload.update(newFile, { error: 'parsing image size'})
            }
            img.src = newFile.blob
          }

        if (newFile) {
            const reader = new FileReader()
            reader.readAsDataURL(newFile.file)
            reader.onload = e => {
                newFile.name = e.target.result
            }
        }
    },

    viewImage(image) {
        if (image['@id']) {
            const baseUrl = process.env.VUE_APP_BASE_URL
            return `${baseUrl}/assets/img/fb_imgs/gallery/${this.trip.id}/${image.name}`
        }

        return image.thumb
    },

    toDataUrl(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    },

    setVideo: function() {
        const self = this,
          url = self.trip.videoUrl,
          regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
          match = url.match(regExp)

        let videoId = null

        if ( match && match[7].length === 11 ){
            videoId = match[7]
        }

        if (videoId) {
            self.videoError = null
            self.trip.videoUrl = `http://youtu.be/${videoId}`
            self.videoId = videoId
            self.trip.videoId = videoId
            return
        }

        self.videoError = 'Não foi possível obter o video com o link informado'
    },

    removeImage(image) {
        const self = this,
          api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.delete(image['@id'])
          .finally(() => {
              self.$store.commit('stopLoading')
          })
    },

    checkForLongBoardingIntervals() {
        const self = this

        const dates = self.trip.boardingPlaces.map(place => place.date ? new Date(place.date) : null).filter(date => date)

        const hasLongInterval = dates.some((date, index) => {
            if (index) {
                const previousDate = dates[index - 1];
                const differenceInTime = Math.abs(date - previousDate);
                const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
                return differenceInDays >= 5;
            }
        });

        if (hasLongInterval) {
            self.showLongBoardingIntervalsModal = true
        }
    },

    checkForLongReturnInterval() {
        const self = this

        const boardingDates = self.trip.boardingPlaces.map(place => place.date ? new Date(place.date) : null).filter(date => date)
        const returnDate = self.trip.stopTime ? new Date(self.trip.stopTime) : null

        if (returnDate) {
            const latestBoardingDate = boardingDates.reduce((latest, current) => {
                return (current > latest) ? current : latest;
            }, new Date());

            if (latestBoardingDate) {
                const differenceInTime = Math.abs(returnDate - latestBoardingDate);
                const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

                if (differenceInDays >= 5) {
                    self.showLongReturnIntervalModal = true
                }
            }
        }
    }
}
